import React from 'react';

interface AppHeaderProps {
  /** URL del logo. Si no se provee, usa el logo por defecto de Dicio. */
  logoSrc?: string;
}

/**
 * Header sticky compartido por todas las páginas.
 * Muestra el logo centrado con fondo blanco semi-transparente.
 */
export const AppHeader: React.FC<AppHeaderProps> = ({ logoSrc }) => (
  <header className="sticky top-0 z-20 border-b border-gray-100 bg-white/90 px-6 py-3 shadow-sm backdrop-blur-sm">
    <div className="mx-auto flex max-w-3xl justify-center">
      <img
        src={logoSrc || '/images/wl/comp_logo.png'}
        alt="Logo"
        className="h-8 w-auto"
      />
    </div>
  </header>
);
